import { createEvent, createStore } from 'effector';

export interface SidebarDndState {
  activeItemId: string | undefined;
}

export const defaultSidebarDndState: SidebarDndState = {
  activeItemId: undefined,
};

export const setSidebarDndActiveItemIdEvent = createEvent<string | undefined>();

export const $sidebarDnd = createStore(defaultSidebarDndState).on(setSidebarDndActiveItemIdEvent, (state, value) => {
  return { ...state, activeItemId: value };
});
